import "./SpinnerBasic.css";
import { CircularProgress, Box } from "@mui/material";

const SpinnerBasic = () => {
  return (
    <div className="spinner-overlay">
      <Box className="loader-container">
        <img
          src="https://voucurtir-bucket.s3.us-east-1.amazonaws.com/bar/geral/logo-circle.svg"
          alt="Loading"
        />
        <CircularProgress className="circleProgress" size={80} thickness={4} />
      </Box>
    </div>
  );
};

export default SpinnerBasic;
